import { Button, Card, CardActions, CardContent, CardMedia, Link, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { AnunciosData } from "../../types/Anuncio/AnuncioData";
import { MdOpenInNew } from "react-icons/md";

interface Props {
    anuncio: AnunciosData,
    heightImg?: string,
    GoTo?: string;
}

export const CardAnuncio: React.FC<Props> = ({ anuncio, heightImg = '300px', GoTo = '' }) => {
    let history = useNavigate();
    const navigate = useNavigate();
    const handleGoto = () => {
        if (GoTo !== '')
            history(GoTo);
    };

    return (
        <Card sx={{
            maxWidth: '100%',
            height: '500px',
            display: 'flex',
            flexDirection: 'column',
        }}
        >
            <CardMedia
                component="img"
                sx={{ maxWidth: '100%', height: heightImg, objectFit: 'contain', }}
                image={anuncio.txImagen}
                title={anuncio.txTitulo}
                onClick={handleGoto}
            />
            <CardContent sx={{ flexGrow: 1 }}>
                <Typography gutterBottom variant="body2" component="div">
                    {anuncio.txTitulo}
                </Typography>
                <Typography component="div" variant="body2" sx={{ color: 'text.secondary' }}>
                    {anuncio.txTexto != null ? anuncio.txTexto.length > 50
                        ? <div className="mb-2">{`${anuncio.txTexto.substring(0, 55)}...`}</div>
                        : <div className="mb-2">{`${anuncio.txTexto.substring(0, 55)}`}</div>
                        : null
                    }
                </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'flex-end', mt: 'auto' }}>
                {/* <div>{anuncio.bdTipo === 'A' && anuncio.dtPublicacion != null ? anuncio.dtPublicacion.split("T")[0] : anuncio.dtInicio.split("T")[0]}</div> */}
                <Link underline="hover" onClick={handleGoto}>
                    Ver más información
                </Link>
            </CardActions>
        </Card>
    );
}